/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { htmlTextCellRenderer } from '@gh/common-internal-shared';
import { TypeService } from '@gh/core-type';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { underlineText } from '@gh/core-util';

import { GridOptions, ICellRendererParams } from 'ag-grid-community';
import { replace } from 'lodash';

const ANCHOR_RE = new RegExp('<a[^>]*>(.*)</a>', 'ig');

@Injectable()
export class TodoInboxDoneGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    dueDate: {
      valueFormatter: (params: any) => this.typeService.get('DayMonth').format(params.value),
    },
    message: {
      cellRenderer: (params: ICellRendererParams) =>
                      htmlTextCellRenderer({
          ...params,
          value: replace(params.value, ANCHOR_RE, (_: any, title: string) => underlineText(title)),
        }),
    },
  };

  constructor(private typeService: TypeService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }

}
